// Toont één rustige melding per nieuw behaalde mijlpaal. Rendert niets.
// Eerste keer ooit: alles wat al behaald is stilletjes als gezien markeren (geen meldingenregen voor bestaande gebruikers).
import { useEffect } from 'react';
import { MILESTONES, achievedIds } from '../../domain/milestones';
import { useLogs, useToast } from '../../state/AppProviders';
import { KEYS } from '../../storage/keys';
import { getRaw, setJSON } from '../../storage/localStore';

/** Bewaarde ids, of null als dit de allereerste keer is (of de opslag onleesbaar is). */
function readSeen(): Set<string> | null {
  const raw = getRaw(KEYS.milestonesSeen);
  if (raw === null) return null;
  try {
    const data: unknown = JSON.parse(raw);
    return Array.isArray(data) ? new Set(data.filter((x): x is string => typeof x === 'string')) : null;
  } catch {
    return null;
  }
}

export default function MilestoneWatcher() {
  const { logs } = useLogs();
  const { showToast } = useToast();

  useEffect(() => {
    const achieved = achievedIds(logs);
    const seen = readSeen();
    if (seen === null) {
      setJSON(KEYS.milestonesSeen, achieved);
      return;
    }
    const fresh = achieved.filter((id) => !seen.has(id));
    if (fresh.length === 0) return;
    // Eerst bewaren, dan tonen: zo meldt een dubbele effect-run (StrictMode) niets twee keer.
    setJSON(KEYS.milestonesSeen, [...seen, ...fresh]);
    if (fresh.length > 3) {
      showToast(`Mijlpaal: ${fresh.length} nieuwe mijlpalen behaald`);
      return;
    }
    for (const id of fresh) {
      const m = MILESTONES.find((x) => x.id === id);
      if (m) showToast(`Mijlpaal: ${m.title}`);
    }
  }, [logs, showToast]);

  return null;
}
